<div class="modal-contentx py-5">
  <div class="modal-body text-center" >
    <div>
        <img width="100px" src="/assets/resource/published-plant.png" alt="img">
    </div>
    <div>
        <h5 class="title mt-3">Publishing Requested!</h5>
        <p class="desc">Your request to publish your property listing has been received, and will undergo a swift quality review prior to listing on Clooper and our third-party channels.</p>
        <app-button (click)="bsModalRef.hide()" [routerLink]="['properties/details', propertyDetails.id]"  lg secondary>View property</app-button>
        <div class="mt-4"> 
            <a (click)="bsModalRef.hide()" routerLink="/">Go to dashboard</a>
        </div>
    </div>

  </div>
</div>